import { Component } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-doc-policy',
  templateUrl: './doc-policy.component.html',
  styleUrls: ['./doc-policy.component.css']
})
export class DocPolicyComponent {
  constructor(private doc:DocumentService,private toastMsgService : ToastmsgService,
    ){
    this.getUserError()
     }
      users:any = [];
    
      onUpload(event: any) {
        // Custom upload handler
        console.log('Uploaded file:', event);
      }
    
      onDownload(user: any) {
        // Simulate rocket-like file download with animation
        alert(`File for ${user.name} is being downloaded!`);
        
        // Logic to download the file
      }
      getUserError(){
        this.doc
        .getPolicyList()
        .subscribe({
          next : (res:any) => {
            if(res.result) {
    
            const data = res.result
            this.users=data
            // console.log(data)         
             } else {
    
             } 
          },error : (err) => {
    
            console.error("Error in fetching all getRoleList");
          }
        }
      )
      }
    
      generatePDF(name:any,filename:any){
        this.doc
        .getPolicypdf(name)
        .subscribe({
          next : (res:any) => {
            console.log(res)
            if(res) {
             let data:any
             data=res
            //  console.log(data)
      
      console.log(data)
            var fileName = filename;
      var blob = data.body;
      const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      var a = document.createElement("a");
      a.href = window.URL.createObjectURL(file);
      a.download = fileName;
      
      // Append the link to the document
      document.body.appendChild(a);
      
      // Trigger a click on the link to start the download
      a.click();
      
      // Remove the link from the document after the download is initiated
      document.body.removeChild(a);
      
      // Revoke the object URL to avoid memory leaks
      window.URL.revokeObjectURL(a.href);
            } else {    
    
            } 
          },error : (err) => {
            console.log(err)
      
      
          }
        }
      )
      
      }
    
      downloadExcelFromBlob(blobData: Blob, fileName: string): void {
        // Step 1: Create a download link
        const link = document.createElement('a');
      
        // Step 2: Create an object URL for the Blob
        const url = window.URL.createObjectURL(blobData);
      
        // Step 3: Set the link's href to the object URL and define the download file name
        link.href = url;
        link.download = `${fileName}.xlsx`;
      
        // Step 4: Append the link to the document and trigger the download
        document.body.appendChild(link);
        link.click();
      
        // Step 5: Clean up - Remove the link from the DOM and revoke the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
      formatTimestamp(timestamp: any): any {
          let convertedValue:any = ""
          if(timestamp){
          let datepipe = new DatePipe("en");
          //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
          convertedValue =  datepipe.transform(timestamp, "dd-MM-yyyy HH:mm:ssa");
          // convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
      
          }
          return convertedValue;
        
      }
      selectedFile:any
      uploadDisable:boolean=false
      onFileSelected(event: any): void {
        console.log(event)
        // this.fileSelected=true;
          this.selectedFile = event.files[0] ?? null;
      
      
      }


      uploadPolicyExcelFile() {

        this.uploadDisable=true;
    
        // const request = {userType:this.createUserType,userStatus:this.createUserStatus,userAlertConfig:this.slideToggleNotify.checked,updateUser:this.slideToggleUpdate.checked}
        this.doc.uploadPolicyExcel(this.selectedFile).subscribe({next : (res:any)=> {
          console.log(res)
          if(res.message==='File Uploaded Successfully.') { 
            
    
            this.uploadDisable=false;
    
            this.toastMsgService.setMsg({msg : "Upload SOP Successfully",msgTitle : "Success", msgType : "I"});
            this.selectedFile=null
            this.getUserError()

            // this.DialogService.open({msg :'View Upload Status',title : "Information",buttonType : "OkCancel"})
           
            // this.DialogService.onResponse((response :  string) => {
             
            //   if(response=="Ok") {
            //     this.router.navigate(["/app/manage-file-upload"]);   
            //          }})
            
          } else {
            this.uploadDisable=false;
    
    
            this.toastMsgService.setMsg({msg : "Failed to Upload",msgTitle : "Warning", msgType : "W"});
    
            this.selectedFile=null
    
    
    
           
          }
      }, error : (err:any)=> {
        this.uploadDisable=false;
    console.log(err)
        // this.uploadDisable=false;
        this.toastMsgService.setMsg({msg : "Failed to Upload",msgTitle : "Warning", msgType : "W"});
    
      }})
        // Handle the uploaded file here.
        // You can access the selected file using this.fileInput.nativeElement.files[0].
        
      }
}
